import urijs from 'urijs';
import topMv from '@/_modules/top/topMv';
import topGl from '@/_modules/top/topGl';
import topNews from '@/_modules/top/topNews';
import topInview from '@/_modules/top/topInview';
// import productSwipe from '@/_modules/top/productSwipe';
import caseSwipe from '@/_modules/top/caseSwipe';
import modalCase from '@/_modules/top/modalCase';
import modalMember from '@/_modules/top/modalMember';
import { isBreakOrContinueStatement } from 'typescript';

class _top {
  //constructor() {}
  init() {
    topMv.init();
    topGl.init();
    topNews.init();
    topInview.init();
    // productSwipe.init();
    caseSwipe.init();
    modalCase.init();
    modalMember.init();

    gEvent.on('popState', this.onPopState.bind(this));
    //gEvent.on('pushState', this.onPushState.bind(this));
  }

  reset() {
    topMv.reset();
    topGl.reset();
    topNews.reset();
    // productSwipe.reset();
    caseSwipe.reset();
    modalCase.reset();
    modalMember.reset();
  }

  mvStart() {
    for (let i in gAMBR.query) {
      if (i === 'redirect') {
        if (gAMBR.query[i].indexOf('/casestudy/') > -1) {
          modalCase.openModal(gAMBR.query[i]);
          break;
        } else if (gAMBR.query[i].indexOf('/member/') > -1) {
          modalMember.openModal(gAMBR.query[i]);
          break;
        }
      }
    }

    //topGl.start();
    topMv.start();
    //topNews.start();
    // productSwipe.start();
    caseSwipe.start();
    modalCase.start();
    modalMember.start();
  }

  inview(id) {
    topInview.show(id);
  }

  onPopState(e) {
    let urlInfo = urijs.parse(e.url);
    const pathArr = urlInfo.path.split('/');

    if (pathArr[1] === 'casestudy') {
      modalCase.openModalState('/casestudy/' + pathArr[2] + '/');
    } else if (pathArr[1] === 'member') {
      modalMember.openModalState('/member/' + pathArr[2] + '/');
    } else {
      const prevInfo = urijs.parse(e.from)
      const prevArr = prevInfo.path.split('/');

      if (prevArr[1] === 'casestudy') {
        modalCase.closeModalState();
      } else if (prevArr[1] === 'member') {
        modalMember.closeModalState();
      }
    }
  }

  /*onPushState(e) {
    console.log('onPushState', e.url);
  }*/
}

const top = new _top();

export default top;